import React, { Component } from 'react';
import NotesCardFooter from '../../../../Components-2025/Notes/CardFooter';
import CustomCard from '../../../../Components-2025/Notes/CustomCard';
import CustomCardHeader from '../../../../Components-2025/QuestionBank/CustomCardHeader';
import ReportCard from '../../../../Components-2025/QuestionBank/ReportCard';
import notesIcon from '../../../../assets/img/notes/notes_icon4.svg';
import ComponentHeader from '../../../../common/ComponentHeader';
import { nextAwareRoute } from '../../../../common/cfa1NextRoutes';
import CustomButton from '../../../../common/CustomButton';
import { messages } from '../../../../common/messages';
import CardBlockLoaderWrapper from '../../../../components/CardBlockLoaderWrapper';
import FlashCard from '../../../../components/FlashCard';
import config from '../../../config/AppRoutes';
import { descriptionKey, notesIdKey, notesNameKey, notesReadingIdKey } from './ApiAttributesKays';
import apiServiceProvider from './ApiService';
import { renderHTMLContent } from '../../../../common/function';
import {
  aiTutorExamYear,
  aiTutorPageUrl,
  aiTutorStem,
  clearAiTutorContext,
  dispatchAiTutorContext,
  dispatchAiTutorExplain,
  AI_TRIGGER_BTN_STYLE,
} from '../../../../common/aiTutorContext';

/* eslint-disable*/

export default class ViewNotes extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      notesList: [],
      currentNoteObj: {},
      isFlashCardHidden: true,
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
  }
  async componentDidMount() {
    const { level, readingId, chapterId } = this.props.params;
    const result = await apiServiceProvider['fetchNotes']({ level, readingId, chapterId });
    if (result.success) {
      const { notes } = result;
      // reading/chapter names ride along in the all-notes response — kept for AI Tutor grounding
      this._readingName = (result.reading && result.reading.readingName) || '';
      this._chapterName = (result.chapterName && result.chapterName.chapterName) || '';
      this.setState({ isLoading: false, notesList: notes });
      await this.onSetCurrentNote(notes);
    }
    this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    // leaving the notes view → drop stale AI Tutor context
    clearAiTutorContext();
  }

  onSetCurrentNote = async (notesData) => {
    const { notesId, readingId } = this.props.params;
    let index;
    if (notesId !== ':notesId') {
      index = notesData.findIndex((item) => item[notesIdKey] === parseInt(notesId, 10));
      this.setState({ currentIndex: index });
    } else {
      index = notesData.findIndex(
        (item) => item[notesReadingIdKey] === parseInt(readingId, 10),
      );
      index = index === -1 ? 0 : index;
      this.setState({ currentIndex: index });
    }
    // tell the AI Tutor which note the student is viewing (context bar + grounding)
    this.dispatchAiContext(notesData[index]);
    this.setState({ isLoading: false });
  };

  buildAiContext = (note) => ({
    exam: 'CFA1',
    exam_year: aiTutorExamYear(), // 2026/2027 from the header's selected exam; null when unknown
    page_url: aiTutorPageUrl(),
    page_type: 'note',
    content_id: note && note[notesIdKey],
    title: note && note[notesNameKey] ? `${note[notesNameKey]} (N. ${note[notesIdKey]})` : 'CFA Level I',
    // reading/chapter names (from the all-notes response) — extra KB grounding + analytics
    reading: this._readingName || '',
    chapter: this._chapterName || '',
    // the note text itself — the strongest grounding signal; postTitle names the concept
    stem: note
      ? aiTutorStem((note.postTitle ? note.postTitle + '. ' : '') + (note[descriptionKey] || ''))
      : '',
  });

  dispatchAiContext = (note) => {
    if (!note) return;
    dispatchAiTutorContext(this.buildAiContext(note));
  };

  askAiAboutNote = () => {
    const { notesList, currentIndex } = this.state;
    const note = notesList[currentIndex];
    if (!note) return;
    dispatchAiTutorExplain({
      context: this.buildAiContext(note),
      message: 'Explain this note in simple terms',
    });
  };
  resetStates = () => {
    this.setState({
      showAnswer: false,
      showReportSection: false,
      selectedChoice: '',
      stopTimer: false,
    });
  };
  replaceRoute = (index) => {
    const { notesList } = this.state;
    const { readingId, chapterId, notesId, level } = this.props.params;
    const { router } = this.context;

    const id = notesList[index] ? notesList[index].id : notesId;

    router.push({
      pathname: nextAwareRoute(config.CFA1_2025_NOTES_VIEW).replace(':level', level)
        .replace(':readingId', readingId)
        .replace(':chapterId', chapterId)
        .replace(':notesId', id),
    });
    this.setState({ currentIndex: index, currentNoteObj: notesList[index] });
    this.dispatchAiContext(notesList[index]);
  };

  getPreviousQuestion = () => {
    const { currentIndex } = this.state;
    if (parseInt(currentIndex, 10) > 0) {
      this.replaceRoute(currentIndex - 1);
      this.resetStates();
    }
  };
  getNextQuestion = () => {
    const { notesList, currentIndex } = this.state;
    const index = parseInt(currentIndex, 10) + 1;
    if (index < notesList.length) {
      this.replaceRoute(index);
      this.resetStates();
    }
  };
  onSaveItemChange = (status) => {
    this.setState({ isFlashCardHidden: status });
  };

  toggleReportSection = () =>
    this.setState((prevState) => ({ showReportSection: !prevState.showReportSection }));

  hideReportSection = () => {
    this.setState({ showReportSection: false });
  };
  render() {
    const { isLoading, notesList, currentIndex, isFlashCardHidden, showReportSection } = this.state;
    const { chapterId, readingId } = this.props.params;
    const { router } = this.context;
    return (
      <div className='row col-sm-12 d-block'>
        {/* //* ============================{{ HEADER START HERE }}========================================== */}
        <ComponentHeader title={messages.NOTES} className='note-section notes_inner_title_wrap '>
          {/* Grouped + wrapping so the row never overflows the viewport on mobile. */}
          <div className='d-flex flex-wrap align-items-center' style={{ gap: 8, marginLeft: 'auto', justifyContent: 'flex-end' }}>
            <CustomButton
              onClick={() =>
                router.push({
                  pathname: nextAwareRoute(config.CFA1_2025_NOTES_LIST).replace(':chapterId', chapterId).replace(
                    ':readingId',
                    readingId,
                  ),
                  state: notesList.length && { notesList },
                })
              }
            >
              {messages.CHANGE_NOTES}
            </CustomButton>
            <CustomButton
              onClick={() =>
                router.push({
                  pathname: nextAwareRoute(config.CFA1_2025_NOTES_READING_LIST).replace(':chapterId', chapterId),
                  state: notesList.length && { notesList },
                })
              }
            >
              {messages.CHANGE_READING}
            </CustomButton>
            <CustomButton onClick={this.askAiAboutNote} btnColor='ai' style={AI_TRIGGER_BTN_STYLE} className='ap-ai-launcher'>✦ Ask AI about this note</CustomButton>
          </div>
        </ComponentHeader>
        {/* //* ============================{{ HEADER ENDED HERE }}=========================================== */}
        <div>
          <CustomCard className="special_notes_view" style={isLoading && { height: '800px' }}>
            <CardBlockLoaderWrapper isLoading={isLoading} />
            {currentIndex >= 0 ? (
              <div>
                <CustomCardHeader
                  headerClassName='sticky-header'
                  navigateButtonClassName='sticky-navigate'
                  headingText={
                    notesList.length &&
                    `${notesList[currentIndex][notesNameKey]} (N. ${
                      notesList[currentIndex][notesIdKey]
                    })`
                  }
                  showPreviousButton={true}
                  showNextButton={true}
                  headerImage={notesIcon}
                  arrayLength={notesList.length}
                  disabledPreviousButton={currentIndex < 1}
                  disabledNextButton={!(currentIndex < notesList.length - 1)}
                  getPreviousQuestion={this.getPreviousQuestion}
                  getNextQuestion={this.getNextQuestion}
                />
                {renderHTMLContent(notesList.length && notesList[currentIndex][descriptionKey], "div", "mt-3")}
                <NotesCardFooter
                  isLoading={isLoading}
                  savePayLoad={{
                    question_id: notesList.length && notesList[currentIndex][notesIdKey],
                  }}
                  favItemId={notesList.length && notesList[currentIndex][notesIdKey]}
                  setChildRef={this.childRef}
                  apiServiceProvider={apiServiceProvider}
                  onSaveItemChange={this.onSaveItemChange}
                  toggleReportSection={this.toggleReportSection}
                />
              </div>
            ) : (
              <h1 className='text-center pt-3 pb-3'>{!isLoading && messages.NO_DATA_FOUND}</h1>
            )}
          </CustomCard>
        </div>
        <div className='col-sm-12 note-section p-0'>
          {currentIndex >= 0 && (
            <div>
              <FlashCard
                item={{ id: notesList.length && notesList[currentIndex][notesIdKey] }}
                type='notes'
                isFlashCardHidden={isFlashCardHidden}
                ref={this.setChildRef}
                exam='cfa1_2024'
              />
              {showReportSection && (
                <ReportCard
                  hideReportSection={this.hideReportSection}
                  apiServiceProvider={apiServiceProvider}
                  itemId={notesList.length && notesList[currentIndex][notesIdKey]}
                  keyId='questionId'
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Notes/View/ViewNotes.jsx